<template>
    <div>
    	<div>
	        <Row class="expand-row">
	            <Col span="8">
	                <span class="expand-key">{{$t('configuration_management.common.cycle')}}: </span>
	                <span class="expand-value">{{ row.cycleName }}</span>
	            </Col>
	            <Col span="8">
	                <span class="expand-key">{{$t('configuration_management.common.continuous')}}: </span>
	                <span class="expand-value">{{ row.continousCycleName }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<Col span="8">
	                <span class="expand-key">{{$t('configuration_management.common.statisticsValue')}}: </span>
	                <span class="expand-value">{{ row.statisticsValueName }}</span>
	            </Col>
	            <Col span="8">
	                <span class="expand-key">{{$t('configuration_management.common.statisticsCount')}}: </span>
	                <span class="expand-value">{{ row.statisticsCountName }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<Col span="8">
	                <span class="expand-key">{{$t('configuration_management.common.sign')}}: </span>
	                <span class="expand-value">{{ row.relationshipSignName }}</span>
	            </Col>
	            <Col span="8">
	                <span class="expand-key">{{$t('configuration_management.common.unit')}}: </span>
	                <span class="expand-value">{{ row.unitName }}</span>
	            </Col>
	        </Row>
	        <Row class="expand-row">
	        	<Col span="8">
	                <span class="expand-key">{{$t('configuration_management.customized_alarm_config.version')}}: </span>
	                <span class="expand-value">{{ row.version }}</span>
	            </Col>
	            <Col span="8">
	                <span class="expand-key">{{$t('configuration_management.common.resourceType')}}: </span>
	                <span class="expand-value">{{ row.resourceTypeName }}</span>
	            </Col>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/customer_defined_alarm_configuration/TableExpand.vue